import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=15e903f6"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"
import style0 from "./DataView.vue?vue&type=style&index=0&id=15e903f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports